// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"65a9fd01","323":"3340fdb5","474":"65a9fd01"}[chunkId] + ".chunk.css";
};